<template>
	<div class="group-nav-panel">
		<el-timeline>
			<el-timeline-item v-for="(item, key, index) in groupsForm" :key="index">
				<span :class="{ active: activeIndex == index }" @click="getActiveIndex(index)">{{
					key
				}}</span>
				<i slot="dot" class="iconfont icon-yuan" v-show="activeIndex == index"></i>
			</el-timeline-item>
		</el-timeline>
	</div>
</template>
<script>
export default {
	name: 'GroupNavPanel',
	props: {
		groupsForm: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			activeIndex: 0
		};
	},
	mounted() {
		window.addEventListener('scroll', this.scrollEvent, true);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrollEvent, true);
	},
	methods: {
		scrollEvent() {
			let scrollItems = document.querySelectorAll('.skytech-form .skytech-card');
			if (scrollItems.length) {
				// 获取距离顶部的距离
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// 获取可视区的高度
				let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// 获取滚动条的总高度
				let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

				for (let i = scrollItems.length - 1; i >= 0; i--) {
					// 判断滚动条滚动距离是否大于当前滚动项可滚动距离
					let judge = scrollTop >= scrollItems[i].offsetTop;
					if (judge) {
						this.activeIndex = i;
						break;
					}
				}
				// 滚动条触底了
				if (scrollTop + windowHeight >= scrollHeight) {
					this.activeIndex = Object.keys(this.groupsForm).length - 1;
				}
			}
		},
		getActiveIndex(index) {
			this.activeIndex = index;
			let jump = document.querySelectorAll('.skytech-form .skytech-card');
			jump[index].scrollIntoView({
				block: 'start'
			});
		}
	}
};
</script>
<style lang="scss">
.group-nav-panel {
	position: fixed;
	top: 100px;
	right: 50px;
	z-index: 999;
	background-color: #FFFFFF;
	box-shadow: 0 2px 10px 0 #EAEAEA;
	padding: 24px 18px;
	border-radius: 4px;

	.active {
		color: #3DA1FF;
	}

	.icon-yuan {
		font-size: 10px;
		background-color: #fff;
		color: #3DA1FF;
	}

	.el-timeline {
		padding-inline-start: 0;

		:last-child {
			padding-bottom: 0;
		}

		.el-timeline-item__content {
			cursor: pointer;

			&:hover {
				color: #3DA1FF;
			}
		}

		.el-timeline-item__tail {
			top: 10px;
		}
	}
}
</style>
